<template>
  <div id="main_div">
    <!-- Home Section start-->
    <div id="home">
      <section>
        <div class="container">
          <div>
            <!-- <b-card no-body> -->
            <b-card class="w-25 mb-2">
              <div class="d-flex">
                <div class="col-3 pr-0 pl-1">
                  <div class="img-fluid">
                    <!-- <img src="images/DepositoSyariah.png" class="card-img-top p-1" alt="..." /> -->
                    <img src="../assets/images/Profile.png" class="w-100" />
                  </div>
                </div>
                <div class="col p-0">
                  <div class="p-2">
                    <span>Hallo, {{ this.currentUser.info.name }} !</span>
                    <span>{{ this.currentUser.info.email }}</span>
                  </div>
                </div>
              </div>
            </b-card>
            <b-tabs pills vertical>
              <b-tab title="Pengajuan Saya">
                <b-card-text>
                  <p>Pengajuan Saya</p>
                  <div class="row">
                    <div class="col col-resp">
                      <div class="d-flex list">
                        <div class="col-4 m-auto">
                          <div class="img-fluid">
                            <img src="../assets/images/TabunganSyariah.png" class="w-100" />
                          </div>
                        </div>
                        <div class="col margin">
                          <div class="mt-3">
                            <h4>Tabungan Syariah</h4>
                            <!-- <br>
                            <h4>Syariah</h4>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col col-resp">
                      <div class="d-flex list">
                        <div class="col-4 m-auto">
                          <div class="img-fluid">
                            <img src="../assets/images/DepositoSyariah.png" class="w-100" />
                          </div>
                        </div>
                        <div class="col margin">
                          <div class="mt-3">
                            <h4>Tabungan Syariah</h4>
                            <!-- <br>
                            <h4>Syariah</h4>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col col-resp">
                      <div class="d-flex list">
                        <div class="col-4 m-auto">
                          <div class="img-fluid">
                            <img src="../assets/images/Simpananproduk.png" class="w-100" />
                          </div>
                        </div>
                        <div class="col margin">
                          <div class="mt-3">
                            <h4>Tabungan Syariah</h4>
                            <!-- <br>
                            <h4>Syariah</h4>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="mtop">
                      <div role="tablist">

                        <b-card no-body class="mb-1"
                         v-for="(item, index) in items"
                          :key="item.index"
                        >
                          <b-card-header header-tag="header" class="p-3" role="tab">
                            <span class="m-1">{{ item.nama_produk }}</span>
                            <b-button v-b-toggle="'acc-'+item.id" variant="yellow" class="chevron">
                              <b-icon icon="arrow-bar-down"></b-icon>
                            </b-button>
                          </b-card-header>
                          <b-collapse :id="'acc-'+item.id" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                              <b-card-text>
                                <div class="row">
                                  <div class="col">
                                    <div class="img-fluid">
                                      <img
                                        src="../assets/images/mitrasmall.png"
                                        class="card-img-top w-75 pt-3"
                                        alt="..."
                                      />
                                    </div>
                                  </div>
                                  <div class="col">
                                    <p>ID Pengajuan :</p>
                                    <p>Tanggal Pengajuan :</p>
                                  </div>
                                  <div class="col">
                                    <p>{{ item.id }}</p>
                                    <p>{{ item.created_at  }}</p>
                                  </div>
                                    <div class="col">
                                      <p>Status Pengajuan :</p>
                                      <p v-if="item.status_pengajuan_id == 1">Menunggu Konfirmasi Admin</p>
                                      <p v-else-if="item.status_pengajuan_id == 2">Follow Up</p>
                                      <p v-else-if="item.status_pengajuan_id == 3">Batal</p>
                                      <p v-else-if="item.status_pengajuan_id == 4">Ditolak Admin</p>
                                      <p v-else-if="item.status_pengajuan_id == 13">Menunggu Konfirmasi Admin</p>
                                      <p v-else>Tidak diketahui</p>
                                    </div>
                                  </div>
                                  <div v-if="item.status_pengajuan_id == 4 || item.status_pengajuan_id == 13" class="row mt-3">
                                    <div class="col-12">
                                      <b-alert show variant="danger">
                                        <h5 class="alert-heading"><b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>Informasi Penolakan</h5>
                                        <p class="mb-1"><strong>Alasan:</strong> {{ item.alasan_pembatalan || '-' }}</p>
                                        <div v-if="item.rejection_detail_fields && item.rejection_detail_fields.length > 0">
                                          <p class="mb-1"><strong>Data atau informasi yang memerlukan perbaikan:</strong></p>
                                          <div class="d-flex flex-wrap gap-2 mb-2">
                                            <b-badge v-for="field in item.rejection_detail_fields" :key="field" variant="warning" class="mr-1 mb-1 text-dark">
                                              {{ formatFieldLabel(field) }}
                                            </b-badge>
                                          </div>
                                          <p class="mt-2 text-dark font-weight-bold">
                                            <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
                                            Silahkan perbarui profil Anda pada field yang disebutkan di atas sebelum melakukan pengajuan kembali.
                                          </p>
                                        </div>
                                      </b-alert>
                                    </div>
                                  </div>
                              </b-card-text>
                            </b-card-body>
                          </b-collapse>
                        </b-card>

                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Profile" active>
                <div role="tablist">
                  <!-- start accordion data diri -->
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-3" role="tab">
                      <span class="m-1">Data Diri</span>
                      <b-button v-b-toggle.accordion-1 variant="yellow" class="chevron">
                          <b-icon icon="arrow-bar-down"></b-icon>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-alert v-if="allRejectedFields.length > 0" show variant="warning" class="mb-4">
                          <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
                          <strong>Data Bermasalah Terdeteksi:</strong> Beberapa data Anda ditandai bermasalah oleh Admin. Silahkan perbaiki field yang berwarna merah di bawah ini.
                        </b-alert>
                        <b-card-text>
                          <div class="container">
                            <b-form>
                            <div class="row">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="namaDepan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nama_depan')}">Nama Depan</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('nama_depan')}" type="text" id="namaDepan" placeholder="Nama Depan" :value="this.profiles.profile.nama_depan" >
                                        <input type="hidden" class="form-control" id="namaDepan" name="user_id" :value="this.profiles.id" >
                                        <input type="hidden" name="id" :value="this.profiles.profile.id" >
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="namaBelakang" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nama_belakang')}">Nama Belakang</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('nama_belakang')}" type="text" id="namaBelakang" name="nama_belakang" placeholder="Nama Belakang" :value="this.profiles.profile.nama_belakang" >
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="email mt-3">
                                        <span :class="{'text-danger font-weight-bold': allRejectedFields.includes('jenis_kelamin')}">Jenis Kelamin</span>
                                        <div class="d-flex">
                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio" name="jenis_kelamin" id="jenisLaki" value="pria" :checked ="this.profiles.profile.jenis_kelamin == 'pria'" >
                                                <label class="form-check-label" for="jenisLaki" :class="{'text-danger': allRejectedFields.includes('jenis_kelamin')}">
                                                    Pria
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="jenis_kelamin" id="jenisWanita" value="wanita" :checked ="this.profiles.profile.jenis_kelamin == 'wanita'" >
                                                <label class="form-check-label" for="jenisWanita" :class="{'text-danger': allRejectedFields.includes('jenis_kelamin')}">
                                                    Wanita
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="email mt-3">
                                        <label for="alamat-ktp" :class="{'text-danger font-weight-bold': allRejectedFields.includes('alamat')}">Alamat Sesuai KTP</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('alamat')}" type="text" id="alamat-ktp" name="alamat" placeholder="Alamat Sesuai KTP" :value="this.profiles.profile.alamat">
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="check-domisili"
                                          :checked ="this.profiles.profile.alamat == this.profiles.profile.alamat_terkini"
                                        >
                                        <label class="form-check-label" for="gridCheck">Alamat domisili sesuai dengan tanda pengenal</label>
                                        <small class="text-danger">(Jika anda mencentang ini, anda tidak perlu mengisi kotak dibawah)</small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="alamat-terkini">Alamat Tinggal Terkini</label>
                                        <br>
                                        <input class="form-control" type="text" id="alamat-terkini" name="alamat_terkini" placeholder="Alamat Tinggal Terkini"
                                          :value="this.profiles.profile.alamat_terkini"
                                          :readonly="this.profiles.profile.alamat == this.profiles.profile.alamat_terkini"
                                        >
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="provinsi">Provinsi</label>
                                        <br>
                                        <input type="hidden" :value="this.profiles.profile.provinsi" id="hidden-provinsi-diri">
                                        <select name="provinsi" class="form-control" id="select-province-diri">
                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="kota">Kota / Kabupaten</label>
                                        <br>
                                        <input type="hidden" :value="this.profiles.profile.kota" id="hidden-kabupaten-diri">
                                        <select name="kota" class="form-control " id="select-kabupaten-diri">
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="kecamatan">Kecamatan</label>
                                        <br>
                                        <input type="hidden" :value="this.profiles.profile.kecamatan" id="hidden-kecamatan-diri">
                                        <select name="kecamatan" class="form-control" id="select-kecamatan-diri"></select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="desa">Desa / Kelurahan</label>
                                        <br>
                                        <input class="form-control" type="text" name="desa" :value="this.profiles.profile.desa" placeholder="Desa / Kelurahan">
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="status_tempat_tinggal">Status Tempat Tinggal</label>
                                        <br>
                                        <select name="status_tempat_tinggal" class="form-control" id="status_tempat_tinggal">
                                            <option disabled>-- Status Tempat Tinggal --</option>
                                            <option value="pribadi" :selected="this.profiles.profile.status_tempat_tinggal == 'pribadi'" >Pribadi</option>
                                            <option value="orangtua" :selected="this.profiles.profile.status_tempat_tinggal == 'orangtua'" >Orang tua</option>
                                            <option value="kontrakan" :selected="this.profiles.profile.status_tempat_tinggal == 'kontrakan'" >Kontrakan</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="negara">Negara</label>
                                        <br>
                                        <input class="form-control" type="text" name="negara" :value="this.profiles.profile.negara">
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="email" :class="{'text-danger font-weight-bold': allRejectedFields.includes('email')}">Alamat Email</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('email')}" type="text" id="email" name="email" placeholder="Alamat Email" :value="this.profiles.email">
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="jenisTandapengenal">Jenis Tanda Pengenal</label>
                                        <br>
                                        <select name="jenis_tanda_pengenal" class="form-control" id="jenisTandapengenal">
                                            <option disabled>-- Pilih tanda pengenal</option>
                                            <option value="ktp" :selected="this.profiles.profile.jenis_tanda_pengenal == 'ktp'" >KTP</option>
                                            <option value="sim" :selected="this.profiles.profile.jenis_tanda_pengenal == 'sim'" >SIM</option>
                                            <option value="passport" :selected="this.profiles.profile.jenis_tanda_pengenal == 'passport'" >Passport</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="nomorTandapengenal">Nomor Tanda Pengenal</label>
                                        <br>
                                        <input class="form-control" type="text" id="nomorTandapengenal" name="nomor_tanda_pengenal" placeholder="Nomor Tanda Pengenal" :value="this.profiles.profile.nomor_tanda_pengenal" >
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="tempatTerbit">Tempat Diterbitkan</label>
                                        <br>
                                        <input class="form-control" type="text" id="tempatTerbit" name="tempat_diterbitkan" placeholder="Tempat Diterbitkan" :value="this.profiles.profile.tempat_diterbitkan" >
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="masa-berlaku">Masa Berlaku Tanda Pengenal</label>
                                        <br>
                                        <div class="form-check form-check-inline">
                                            <input class="form-control" type="text" id="masa-berlaku" name="masa_berlaku_tanda_pengenal" placeholder="Masa Berlaku Tanda Pengenal" :value="this.profiles.profile.masa_berlaku_tanda_pengenal" :readonly="this.profiles.profile.masa_berlaku_tanda_pengenal == 'seumur hidup'">
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="checkbox" id="seumur-hidup-check"  :checked="this.profiles.profile.masa_berlaku_tanda_pengenal == 'seumur hidup'" >
                                            <label class="form-check-label" for="inlineCheckbox2">Seumur Hidup</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="tempatLahir">Tempat Lahir</label>
                                        <br>
                                        <input class="form-control" type="text" id="tempatLahir" name="tempat_lahir" placeholder="Tempat Lahir" :value="this.profiles.profile.tempat_lahir">
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="tanggalLahir">Tanggal Lahir</label>
                                        <br>
                                        <input class="form-control" type="date" id="tanggalLahir" name="tanggal_lahir" placeholder="Tempat Lahir" :value="this.profiles.profile.tanggal_lahir">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="status_pernikahan">Status Pernikahan</label>
                                        <br>
                                        <select name="status_pernikahan" class="form-control" id="status_pernikahan">
                                            <option disabled>-- Pilih status pernikahan --</option>
                                            <option value="belum_menikah" :selected="this.profiles.profile.status_pernikahan == 'belum_menikah'" >Belum Menikah</option>
                                            <option value="menikah" :selected="this.profiles.profile.status_pernikahan == 'menikah'">Menikah</option>
                                            <option value="cerai_hidup" :selected="this.profiles.profile.status_pernikahan == 'cerai_hidup'">Cerai Hidup</option>
                                            <option value="cerai_mati" :selected="this.profiles.profile.status_pernikahan == 'cerai_mati'">Cerai Mati</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="agama">Agama</label>
                                        <br>
                                        <select name="agama" class="form-control" id="agama">
                                            <option disabled>-- Pilih Agama --</option>
                                            <option value="islam" :selected="this.profiles.profile.agama == 'islam'">Islam</option>
                                            <option value="kristen" :selected="this.profiles.profile.agama == 'kristen'">Kristen</option>
                                            <option value="hindu" :selected="this.profiles.profile.agama == 'hindu'">Hindhu</option>
                                            <option value="budha" :selected="this.profiles.profile.agama == 'budha'">Budha</option>
                                            <option value="konghucu"  :selected="this.profiles.profile.agama == 'konghucu'">Konghucu</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="pendidikan">Pendidikan</label>
                                        <br>
                                        <select name="pendidikan" class="form-control" id="pendidikan">
                                            <option disabled>-- Pilih pendidikan --</option>
                                            <option value="tidak_sekolah" :selected="this.profiles.profile.pendidikan == 'tidak_sekolah'" >Tidak Sekolah</option>
                                            <option value="belum_tamat_sd" :selected="this.profiles.profile.pendidikan == 'belum_tamat_sd'" >Belum tamat SD / Sederajat</option>
                                            <option value="tamat_sd" :selected="this.profiles.profile.pendidikan == 'tamat_sd'" >Tamat SD / Sederajat</option>
                                            <option value="SLTP" :selected="this.profiles.profile.pendidikan == 'SLTP'" >SLTP / Sederajat</option>
                                            <option value="SLTA" :selected="this.profiles.profile.pendidikan == 'SLTA'" >SLTA / Sederajat</option>
                                            <option value="diploma_1/2" :selected="this.profiles.profile.pendidikan == 'diploma_1/2'" >DIPLOMA I / II</option>
                                            <option value="akademi/diploma_3/sarjana_muda" :selected="this.profiles.profile.pendidikan == 'akademi/diploma_3/sarjana_muda'" >AKADEMI/ DIPLOMA III/S. MUDA</option>
                                            <option value="strata_1/diploma_4" :selected="this.profiles.profile.pendidikan == 'strata_1/diploma_4'" >DIPLOMA IV/ STRATA I</option>
                                            <option value="strata_2" :selected="this.profiles.profile.pendidikan == 'strata_2'" >STRATA II</option>
                                            <option value="strata_3" :selected="this.profiles.profile.pendidikan == 'strata_3'" >STRATA III</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="kewarganegaraan">Kewarnegaraan</label>
                                        <br>
                                        <select name="kewarganegaraan" class="form-control" id="kewarganegaraan">
                                            <option disabled>-- Pilih Kewarganegaraan --</option>
                                            <option value="wni" :selected="this.profiles.profile.kewarganegaraan == 'wni'" >WNI</option>
                                            <option value="wna" :selected="this.profiles.profile.kewarganegaraan == 'wna'" >WNA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="noTelepon" :class="{'text-danger font-weight-bold': allRejectedFields.includes('no_handphone')}">No. Telepon/Handphone</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('no_handphone')}" type="text" id="noTelepon" name="no_handphone" placeholder="No. Telepon/Handphone" :value="this.profiles.profile.no_handphone">
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="noTeleponalternatif" :class="{'text-danger font-weight-bold': allRejectedFields.includes('no_hp_alternatif')}">No. Telepon/Handphone Alternatif</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('no_hp_alternatif')}" type="text" id="noTeleponalternatif" name="no_hp_alternatif" placeholder="No. Telepon/Handphone Alternatif" :value="this.profiles.profile.no_hp_alternatif" >
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="npwp" :class="{'text-danger font-weight-bold': allRejectedFields.includes('npwp')}">NPWP</label>
                                        <br>
                                        <input class="form-control" :class="{'is-invalid border-danger': allRejectedFields.includes('npwp')}" type="text" id="npwp" name="npwp" placeholder="NPWP" :value="this.profiles.profile.npwp">
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="namaIbu">Nama Ibu Kandung</label>
                                        <br>
                                        <input class="form-control" type="text" id="namaIbu" name="nama_gadis_ibu_kandung" placeholder="Nama Ibu Kandung" :value="this.profiles.profile.nama_gadis_ibu_kandung" >
                                    </div>
                                </div>
                            </div>

                            <div class="row ">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="tujuan_pembukaan_rekening_id">Tujuan Pembukaan Rekening</label>
                                        <br>
                                        <select class="form-control" id="tujuan_pembukaan_rekening_id" name="tujuan_pembukaan_rekening_id">

                                        </select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="sumber_dana_id">Sumber Dana</label>
                                        <br>
                                        <select class="form-control" id="sumber_dana_id" name="sumber_dana_id">

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col">
                                    <div class="alamat mt-3">
                                        <label for="fname">Perkiraan Nilai Transaksi dalam 1 tahun</label>
                                        <br>
                                        <div class="form-check">
                                            <input class="form-check-input" :selected="this.profiles.profile.perkiraan_nilai_transaksi == 'Rp. 5.000.000 - Rp. 25.000.000'" type="radio" name="perkiraan_nilai_transaksi" id="perkiraan_nilai_transaksi" value="Rp. 5.000.000 - Rp. 25.000.000" checked>
                                            <label class="form-check-label" for="perkiraan_nilai_transaksi">
                                                Rp. 5.000.000 - Rp. 25.000.000
                                            </label>
                                          </div>
                                          <div class="form-check">
                                            <input class="form-check-input" :selected="this.profiles.profile.perkiraan_nilai_transaksi == 'Rp. 25.000.001 - Rp. 50.000.000'" type="radio" name="perkiraan_nilai_transaksi" id="perkiraan_nilai_transaksi" value="Rp. 25.000.001 - Rp. 50.000.000">
                                            <label class="form-check-label" for="perkiraan_nilai_transaksi">
                                                Rp. 25.000.001 - Rp. 50.000.000
                                            </label>
                                          </div>
                                          <div class="form-check">
                                            <input class="form-check-input" :selected="this.profiles.profile.perkiraan_nilai_transaksi == 'Rp. 50.000.001 - Rp. 100.000.000'" type="radio" name="perkiraan_nilai_transaksi" id="perkiraan_nilai_transaksi" value="Rp. 50.000.001 - Rp. 100.000.000">
                                            <label class="form-check-label" for="perkiraan_nilai_transaksi">
                                                Rp. 50.000.001 - Rp. 100.000.000
                                            </label>
                                          </div>
                                          <div class="form-check">
                                            <input class="form-check-input" :selected="this.profiles.profile.perkiraan_nilai_transaksi == '> Rp. 100.000.000'" type="radio" name="perkiraan_nilai_transaksi" id="perkiraan_nilai_transaksi" value="> Rp. 100.000.000">
                                            <label class="form-check-label" for="jeniperkiraan_nilai_transaksisWanita">
                                                > Rp. 100.000.000
                                            </label>
                                          </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="alamat mt-4">
                                        <button type="submit" class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0" >Ubah Data Diri</button>
                                    </div>
                                </div>

                                </div>
                              </b-form>
                            </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <!-- end accordion data diri -->

                  <!-- start accordion data pekerja dan penghasilan -->
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-3" role="tab">
                      <span class="m-1">Data Pekerja dan Penghasilan</span>
                      <b-button v-b-toggle.accordion-3 variant="yellow" class="chevron">
                        <b-icon icon="arrow-bar-down"></b-icon>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <div class="container">
                                <b-form >
                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="latarBelakang">Latar Belakang Pekerjaan</label>
                                              <br>
                                              <input type="hidden" name="id" :value="this.profiles.data_pekerjaan.id">
                                              <input type="hidden" name="user_id" :value="this.profiles.data_pekerjaan.user_id">
                                              <textarea class="form-control" name="latar_belakang" id="latarBelakang" cols="42" rows="3" :value="this.profiles.data_pekerjaan.latar_belakang" ></textarea>
                                          </div>
                                      </div>
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="bidang_usaha_id">Pilih Bidang</label>
                                              <br>
                                              <select name="bidang_usaha_id" class="form-control" id="bidang_usaha_id">

                                              </select>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Nama Tempat Bekerja</label>
                                              <br>
                                              <input class="form-control" type="text" id="nama_tempatkerja" name="nama_tempatkerja" placeholder="Nama Tempat Bekerja" :value="this.profiles.data_pekerjaan.nama_tempatkerja" >
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Jabatan Pekerjaan</label>
                                              <br>
                                              <input class="form-control" type="text" id="jabatan" name="jabatan" placeholder="Jabatan Pekerjaan" :value="this.profiles.data_pekerjaan.jabatan" >
                                          </div>
                                      </div>
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Lama Bekerja</label>
                                              <br>
                                              <input class="form-control" type="text" id="lama_bekerja" name="lama_bekerja" placeholder="Lama Bekerja" :value="this.profiles.data_pekerjaan.lama_bekerja" >
                                              <span>Bulan</span>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Alamat Tempat Bekerja</label>
                                              <br>
                                              <input class="form-control" type="text" id="alamat_tempatkerja" name="alamat_tempatkerja" placeholder="Alamat Tempat Bekerja" :value="this.profiles.data_pekerjaan.alamat_tempatkerja" >
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="provinsi">Provinsi</label>
                                              <br>
                                              <input type="hidden" :value="this.profiles.data_pekerjaan.propinsi" id="hidden-provinsi-pekerjaan">
                                              <select name="propinsi" class="form-control" id="select-province-pekerjaan">
                                              </select>
                                          </div>
                                      </div>
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="exampleFormControlSelect7">Kota / Kabupaten</label>
                                              <br>
                                              <input type="hidden" :value="this.profiles.data_pekerjaan.kota" id="hidden-kabupaten-pekerjaan">
                                              <select name="kota" class="form-control" id="select-kabupaten-pekerjaan">
                                              </select>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="kecamatan">Kecamatan</label>
                                              <br>
                                              <input type="hidden" :value="this.profiles.data_pekerjaan.kecamatan" id="hidden-kecamatan-pekerjaan">
                                              <select name="kecamatan" class="form-control" id="select-kecamatan-pekerjaan">
                                              </select>
                                          </div>
                                      </div>
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="desa">Desa / Kelurahan</label>
                                              <br>
                                              <input class="form-control" type="text" name="desa" :value="this.profiles.data_pekerjaan.desa" placeholder="Desa / Kelurahan">
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Kode Pos</label>
                                              <br>
                                              <input class="form-control" type="text" id="kode_pos" name="kode_pos" placeholder="Kode Pos" :value="this.profiles.data_pekerjaan.kode_pos" >
                                          </div>
                                      </div>
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Negara</label>
                                              <br>
                                              <input class="form-control" type="text" id="negara" name="negara" placeholder="Negara" :value="this.profiles.data_pekerjaan.negara" >
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row ">
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">No. Telp Kantor</label>
                                              <br>
                                              <input class="form-control" type="text" id="no_telpon" name="no_telpon" placeholder="No. Telp Kantor" :value="this.profiles.data_pekerjaan.no_telpon" >
                                          </div>
                                      </div>
                                      <div class="col">
                                          <div class="alamat mt-3">
                                              <label for="fname">Rata-rata Penghasilan dalam 1 Tahun</label>
                                              <br>
                                              <select class="form-control" name="ratarata_penghasilan_setahun">
                                                  <option value="" disabled selected hidden>-- Rata-rata Penghasilan dalam 1 Tahun --</option>
                                                  <option value="Rp. 60.000.000 <" :selected="this.profiles.data_pekerjaan.ratarata_penghasilan_setahun == 'Rp. 60.000.000 <'" >Rp. 60.000.000 < </option>
                                                  <option value="Rp. 60.000.000 - Rp. 100.000.000" :selected="this.profiles.data_pekerjaan.ratarata_penghasilan_setahun == 'Rp. 60.000.000 - Rp. 100.000.000'" >Rp. 60.000.000 - Rp. 100.000.000</option>
                                                  <option value="Rp. > Rp. 100.000.000" :selected="this.profiles.data_pekerjaan.ratarata_penghasilan_setahun == 'Rp. > Rp. 100.000.000'" >Rp. > Rp. 100.000.000</option>
                                              </select>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="alamat mt-4 mb-3">
                                      <button type="submit" class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0">Ubah Data Perusahaan</button>
                                  </div>
                              </b-form>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <!-- end accordion data pekerja dan penghasilan-->

                  <!-- start accordion data usaha -->
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-3" role="tab">
                      <span class="m-1">Data Usaha</span>
                      <b-button v-b-toggle.accordion-4 variant="yellow" class="chevron">
                        <b-icon icon="arrow-bar-down"></b-icon>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <div class="container">
                            <b-form >
                              <div class="row ">
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="fname">Nama Organisasi/Perusahaan</label>
                                          <br>
                                          <input class="form-control" type="text" id="nama_perusahaan" name="nama_perusahaan" placeholder="Nama Organisasi/Perusahaan" :value="this.profiles.data_usaha.nama_perusahaan" >
                                          <input type="hidden" name="user_id" :value="this.profiles.data_usaha.user_id" >
                                          <input type="hidden" name="id" :value="this.profiles.data_usaha.id" >
                                      </div>
                                  </div>
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="fc_identitas_diri_pimpinan">Foto kopi Identitas Pimpinan</label>
                                          <br>
                                          <b-form-file
                                            name="fc_identitas_diri_pimpinan"
                                            placeholder="Pilih dari berkas atau tarik file kesini .. "
                                            drop-placeholder="Taruh disini .. "
                                          ></b-form-file>
                                      </div>
                                  </div>
                              </div>

                              <div class="row ">
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="npwp_perusahaan">NPWP Perusahaan</label>
                                          <br>
                                          <input class="form-control" type="text" id="npwp_perusahaan" name="npwp_perusahaan" placeholder="NPWP Perusahaan" :value="this.profiles.data_usaha.npwp_perusahaan">
                                      </div>
                                  </div>
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <input type="hidden" name="attachment_usaha_id" :value="this.profiles.attachment.id">
                                          <label for="fc_npwp_perusahaan">Foto kopi NPWP perusahaan</label>
                                          <br>
                                          <b-form-file
                                            name="fc_npwp_perusahaan"
                                            placeholder="Pilih dari berkas atau tarik file kesini .. "
                                            drop-placeholder="Taruh disini .. "
                                          ></b-form-file>
                                      </div>
                                  </div>
                              </div>

                              <div class="row ">
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="no_akta">No. Akta</label>
                                          <br>
                                          <input class="form-control" type="text" id="no_akta" name="no_akta" placeholder="No. Akta" :value="this.profiles.data_usaha.no_akta" >
                                      </div>
                                  </div>
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="fc_surat_kuasa">Foto kopi Surat Kuasa dari Pimpinan</label>
                                          <br>
                                          <b-form-file
                                            name="fc_surat_kuasa"
                                            placeholder="Pilih dari berkas atau tarik file kesini .. "
                                            drop-placeholder="Taruh disini .. "
                                          ></b-form-file>
                                      </div>
                                  </div>
                              </div>

                              <div class="row ">
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="no_surat_izin_usaha">Surat Izin Usaha</label>
                                          <br>
                                          <input class="form-control" type="text" id="no_surat_izin_usaha" name="no_surat_izin_usaha" placeholder="Surat Izin Usaha" :value="this.profiles.data_usaha.no_surat_izin_usaha" >
                                      </div>
                                  </div>
                                  <div class="col">
                                      <div class="alamat mt-3">
                                          <label for="fc_surat_izin_usaha">Foto kopi Surat Izin Usaha</label>
                                          <br>
                                          <b-form-file
                                            name="fc_surat_izin_usaha"
                                            placeholder="Pilih dari berkas atau tarik file kesini .. "
                                            drop-placeholder="Taruh disini .. "
                                          ></b-form-file>
                                      </div>
                                  </div>
                              </div>

                              <div class="alamat mt-4 mb-2">
                                  <button type="submit" class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0">Ubah Data Perusahaan</button>
                              </div>
                            </b-form>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <!-- end accordion data usaha-->

                  <!-- start accordion ganti kata sandi -->
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-3" role="tab">
                      <span class="m-1">Ganti Kata Sandi</span>
                      <b-button v-b-toggle.accordion-5 variant="yellow" class="chevron">
                        <b-icon icon="arrow-bar-down"></b-icon>
                      </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <div class="container">
                            <div class="row">
                              <div class="col">
                                <div class="alamat mt-3">
                                  <label for="password">Kata Sandi Lama</label>
                                  <br />
                                  <input class="form-control" type="password" id="oldpassword" name="oldpassword" placeholder="Kata Sandi Lama">
                                  <input type="hidden" name="id" :value="this.profiles.id" >
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="alamat mt-3">
                                  <label for="password">Kata Sandi Baru</label>
                                  <br />
                                  <input class="form-control" type="password" id="newpassword" name="newpassword" placeholder="Kata Sandi Baru">
                                  <!-- <button type="password" @click="switchVisibility">show / hide</button> -->
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="alamat mt-3">
                                  <label for="fname">Konfirmasi Kata Sandi Baru</label>
                                  <br />
                                  <input class="form-control" type="password" id="password" name="confirmpassword" placeholder="Konfirmasi Kata Sandi Baru">
                                </div>
                              </div>
                            </div>

                            <div class="alamat mt-4 mb-3">
                              <button type="submit" class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0" >Update Kata Sandi</button>
                            </div>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <!-- end accordion ganti kata sandi-->
                </div>
              </b-tab>
            </b-tabs>
            <!-- </b-card> -->
          </div>
        </div>
      </section>
    </div>
    <!--Home Section End -->

    <!-- Footer Section start -->
    <section>
      <Footer />
    </section>
    <!-- Footer Section End -->

    <js />
  </div>
</template>

<script>
import Pengajuan from '../api/pengajuan.js';
import User from '../api/user.js';

export default {
  name: "PengajuanSaya",
   data() {
    return {
      items: [],
      profiles: []
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    allRejectedFields() {
      if (!this.items || this.items.length === 0) return [];
      
      // Filter hanya pengajuan yang ditolak (status 4)
      const rejectedOnes = this.items.filter(item => item.status_pengajuan_id == 4);
      if (rejectedOnes.length === 0) return [];

      // Sortir untuk mendapatkan yang terbaru
      rejectedOnes.sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at));
      const latest = rejectedOnes[0];

      return latest.rejection_detail_fields || [];
    }
  },
  beforeCreate: function () {
    document.body.className = "";
  },
  methods: {
    loadData() {
      Pengajuan.pengajuanFunder()
      .then(res => {
        // console.log(res.data);
        this.items = res.data.data
      })

      User.show(this.currentUser.info.id)
      .then(res => {
        // console.log(res.data);
        this.profiles = res.data.data
      })
    },
    formatFieldLabel(f) {
      if (!f) return '';
      const fieldKey = f.toLowerCase().replace(/ /g, '_');
      
      // Special Mappings
      if (fieldKey.includes('nama_pihak_terkait') || fieldKey.includes('related_party_name')) return 'NAMA AHLI WARIS';
      if (fieldKey.includes('hubungan_pihak_terkait') || fieldKey.includes('related_party_relationship')) return 'HUBUNGAN AHLI WARIS';
      if (fieldKey.includes('no_hp_pihak_terkait') || fieldKey.includes('related_party_phone')) return 'NOMOR TELEPON AHLI WARIS';
      if (fieldKey.includes('alamat_pihak_terkait') || fieldKey.includes('related_party_address')) return 'ALAMAT AHLI WARIS';
      if (fieldKey === 'pihak_terkait') return 'AHLI WARIS';
      
      if (fieldKey === 'npwp_attachment' || fieldKey === 'taxpayer_document_path') return 'NPWP GAMBAR / PDF';
      if (fieldKey === 'alamat_terkini' || fieldKey === 'current_address') return 'ALAMAT DOMISILI';
      if (fieldKey === 'ratarata_penghasilan_perbulan' || fieldKey === 'estimated_transaction_value') return 'RATA-RATA PENGHASILAN DALAM 1 BULAN';
      if (fieldKey === 'nama_tempatkerja' || fieldKey === 'company_name') return 'NAMA TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'alamat_tempatkerja' || fieldKey === 'company_address') return 'ALAMAT TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'jabatan' || fieldKey === 'position_id') return 'JABATAN';
      if (fieldKey === 'bank_id' || fieldKey === 'bank') return 'NAMA BANK';
      if (fieldKey === 'account_number') return 'NOMOR REKENING';
      if (fieldKey === 'account_name') return 'NAMA PEMILIK REKENING';
      if (fieldKey === 'taxpayer_number' || fieldKey === 'npwp') return 'NPWP';
      if (fieldKey === 'identity_number') return 'NOMOR IDENTITAS / KTP';
      if (fieldKey === 'gender' || fieldKey === 'jenis_kelamin') return 'JENIS KELAMIN';
      if (fieldKey === 'identity_address' || fieldKey === 'alamat') return 'ALAMAT KTP';
      if (fieldKey === 'place_of_birth' || fieldKey === 'tempat_lahir') return 'TEMPAT LAHIR';
      if (fieldKey === 'date_of_birth' || fieldKey === 'tanggal_lahir') return 'TANGGAL LAHIR';
      if (fieldKey === 'nationality' || fieldKey === 'kewarganegaraan') return 'KEWARGANEGARAAN';
      
      return f.replace(/_id$/i, '').replace(/_/g, ' ').toUpperCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/public/pengajuan-saya2.vue